<script lang="ts">
	import { DefaultLoading } from "@hitit/new_ui";
	export let alwaysCentermode = false;

</script>

<div class="cover" class:alwaysCentermode>
	<div class="inner">
		<div class="spinner">
			<DefaultLoading />
		</div>
		<slot />
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.cover {
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(240, 240, 244, 0.6);
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 9999;

		.inner {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 30px;

			.spinner {
				width: 60px;
				height: 60px;
			}
		}
	}

	@include DesktopSize {
		.cover {
			left: 266px;

			&.alwaysCentermode {
				left: 0px;
			}
		}
	}

</style>
